var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2633 7.99977C17.2633 8.1945 17.1455 8.45325 17.026 8.57896L10.2891 15.7372C9.97457 16.0624 9.46498 16.1 9.09843 15.7701C8.77065 15.4749 8.76242 14.8996 9.06553 14.5791L14.4733 8.84209L0.842047 8.84209C0.376812 8.84209 -4.95914e-07 8.46497 -5.26513e-07 8.00004C-5.57132e-07 7.53481 0.37712 7.158 0.842047 7.158L14.4733 7.15799L9.06553 1.42096C8.76243 1.10053 8.78386 0.539215 9.09843 0.230262C9.43032 -0.0960456 9.97957 -0.0669701 10.2891 0.263157L17.026 7.42112C17.2239 7.61526 17.26 7.80211 17.2633 7.99977Z",
    fill: "#DB7F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.8aad3083725885e1362a38cbc22c2c80.svg";
export { ForwardRef as ReactComponent };